import React from 'react';
import { CheckIcon } from 'lucide-react';
import { PriceCta } from '../PriceCta';
import { finalIncludes, images } from '../../data/offer';
export function FinalCta() {
  return <section aria-labelledby="final-cta" className="bg-navy-950 px-4 py-16 text-white sm:py-24" data-id="element-165" data-mp="1np9e0od82n9r">
      <div className="mx-auto max-w-6xl lg:grid lg:grid-cols-2 lg:items-center lg:gap-14" data-id="element-166" data-mp="1snt2owj7ad5t">
        <div data-id="element-167" data-mp="1eoba062safr6">
          <p className="font-display text-sm font-bold uppercase tracking-[0.14em] text-aqua" data-id="element-168" data-mp="1ens1th2xr5qc">Ready to organize your ABG studies?</p>
          <h2 id="final-cta" className="mt-3 font-display text-[2.1rem] font-black leading-[1.05] sm:text-5xl [text-wrap:balance]" data-id="element-169" data-mp="1iqobujeettio">
            Build a more structured approach to arterial blood gas interpretation
          </h2>
          <div className="mt-6 space-y-4 text-lg leading-relaxed text-white/75" data-id="element-170" data-mp="19rb3ju20vazj">
            <p data-id="element-171" data-mp="2z4oa7pxlxb3t">You don’t need another collection of disconnected notes.</p>
            <p data-id="element-172" data-mp="3426l3lv6q0eg">
              You need a structured way to study the fundamentals, organize acid-base concepts, review compensation principles,
              and practice explaining your reasoning.
            </p>
          </div>

          <div className="mt-8 rounded-3xl bg-white p-2" data-id="element-173" data-mp="3tf60vpyyg127">
            <img src={images.mockup} alt="The complete ABG Clinical Roadmap collection" className="w-full rounded-2xl" loading="lazy" data-id="element-174" data-mp="b1ooghva7c1e" />
          </div>
        </div>

        <div className="mt-10 lg:mt-0" data-id="element-175" data-mp="3ffn41tblgc57">
          <div className="rounded-3xl bg-navy-900 p-6 ring-1 ring-white/10 sm:p-8" data-id="element-176" data-mp="3fgogo289d6p1">
            <h3 className="text-sm font-extrabold uppercase tracking-wider text-aqua" data-id="element-177" data-mp="3ah3jnxcnf8ey">Your complete collection includes</h3>
            <ul className="mt-4 space-y-3" data-id="element-178" data-mp="3oh4i765fy3r9">
              {finalIncludes.map(c => <li key={c} className="flex items-center gap-3 text-[17px] font-semibold" data-id="element-179" data-mp="3jg700tkfl9pr">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-ok" data-id="element-180" data-mp="13pb10fmhlr0e">
                    <CheckIcon className="h-3.5 w-3.5" strokeWidth={3.5} aria-hidden="true" data-id="element-181" data-mp="ypzj33adwfh8" />
                  </span>
                  {c}
                </li>)}
            </ul>

            <div className="my-7 border-t border-white/10 pt-7 text-center" data-id="element-182" data-mp="1bwm1lr2d8ks">
              <p className="font-semibold text-white/80" data-id="element-183" data-mp="5ejb5ewcofea">Get the complete ABG Clinical Roadmap™ for just</p>
              <p className="mt-1 font-display text-8xl font-black leading-none text-cta" data-id="element-184" data-mp="adw6ko1aeush">$27</p>
              <p className="mt-2 text-sm font-extrabold uppercase tracking-wider text-white/70" data-id="element-185" data-mp="39t19286865wn">
                USD · One-time payment · Digital educational product
              </p>
            </div>

            <PriceCta dark label="Yes! I want the ABG Clinical Roadmap™" note="Instant digital access · No monthly subscription" data-id="element-186" data-mp="3isnz5xti7pae" />
            <p className="mt-4 text-center text-xs text-white/50" data-id="element-187" data-mp="2q4s570vbkbhb">Review the applicable delivery and refund terms at checkout.</p>
          </div>
        </div>
      </div>
    </section>;
}